import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import { navLinksdata } from '../../constants';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from '../LanguageSwitcher';
import logo from '../../assets/logo.svg';
import { motion } from "framer-motion";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="w-full h-auto fixed top-0 z-50 flex justify-center px-4 py-4 font-titleFont">
      <div className="w-full max-w-7xl h-20 bg-bodyColor/70 backdrop-blur-2xl rounded-full shadow-lg border border-white/10 flex justify-between items-center px-6 lg:px-12 transition-all duration-300">
        <div className="flex items-center h-full">
          <Link to="/">
            <motion.img
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              src={logo}
              alt="logo Axel Chevenement"
              className="h-12 w-auto filter drop-shadow-sm"
            />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden mdl:flex">
          <ul className="flex items-center gap-6 lg:gap-10">
            {navLinksdata.map(({ _id, title, link }, index) => (
              <motion.li
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-sm font-medium text-gray-300 tracking-wide cursor-pointer hover:text-white transition-colors duration-300 relative group"
                key={_id}
              >
                <Link
                  to="/"
                  onClick={() => {
                    const element = document.getElementById(link);
                    element?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {t(`navbar.${title}`)}
                </Link>
                <span className="absolute -bottom-1 left-0 w-0 h-[1.5px] bg-sky-500 transition-all group-hover:w-full duration-300 rounded-full"></span>
              </motion.li>
            ))}
            <motion.li
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <LanguageSwitcher />
            </motion.li>
          </ul>
        </div>

        {/* Mobile Menu Icon */}
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-white/10 w-10 h-10 inline-flex items-center justify-center rounded-full text-white cursor-pointer hover:bg-white/20 transition-all"
        >
          <FiMenu />
        </span>

        {/* Mobile Menu Overlay */}
        {showMenu && (
          <div className="w-full h-screen absolute top-0 left-0 bg-transparent z-50">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="w-[85%] sm:w-[60%] h-full absolute top-0 right-0 bg-[#0F172A]/98 backdrop-blur-3xl p-8 shadow-2xl border-l border-white/5 flex flex-col"
            >
              <div className="flex justify-between items-center mb-8">
                <img src={logo} alt="logo" className="h-10 w-auto" />
                <span
                  onClick={() => setShowMenu(false)}
                  className="text-gray-400 hover:text-white duration-300 text-2xl cursor-pointer bg-white/5 p-2 rounded-full"
                >
                  <MdClose />
                </span>
              </div>

              <ul className="flex flex-col gap-6">
                {navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-lg font-medium text-gray-300 hover:text-white duration-300 border-b border-white/5 pb-2"
                  >
                    <Link
                      to="/"
                      onClick={() => {
                        setShowMenu(false);
                        const element = document.getElementById(item.link);
                        element?.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      {t(`navbar.${item.title}`)}
                    </Link>
                  </li>
                ))}
                <li className="pt-4">
                  <LanguageSwitcher />
                </li>
              </ul>

              <div className="mt-auto flex gap-4">
                <a href="https://www.linkedin.com/in/axel-chevenement/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:bg-sky-600 transition-all duration-300">
                  <FaLinkedinIn />
                </a>
              </div>
            </motion.div>
            {/* Click outside to close */}
            <div className="w-full h-full" onClick={() => setShowMenu(false)}></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
